import { FormGroup } from "reactstrap"
import { LabelText } from "./Input"
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

export const ImageUpload = ({ validateSizeError, profilePicture, isProfile, inputFileRef, removeProfilePicture, handleImageChange, isFromProfileScreen }) => {
  return (
    <FormGroup>
      <div className="image-div-tag">
        <LabelText
          htmlFor={"logo"}
          classLabelName={"ms-0 rv-form-label"}
          displayText={"Photo Upload"}
        />
        <LabelText
          htmlFor={"logo"}
          classLabelName={`d-block ms-0 rv-sub-label ${validateSizeError ? "rv-label-danger" : "rv-label-muted"
            } `}
          displayText={
            validateSizeError
              ? validateSizeError
              : "JPEG, PNG, SVG format, upto 10 MB"
          }
        />
        <div
          className={`image-border-style ms-0 ${validateSizeError ? "border-danger" : ""
            }`}
        >

          {profilePicture ? (
            <>
              <img
                src={
                  isProfile
                    ? URL.createObjectURL(profilePicture)
                    : profilePicture
                }
                alt="Logo Preview"
                className={isFromProfileScreen ? "w-h-130" : "to-img-tag"}
              />
              <button
                type='button'
                onClick={removeProfilePicture}
                className="img-remove-button"
              >
                <span className="x-mark">×</span>
              </button>
            </>
          ) : (
            <>
              <label htmlFor="logoInput" className="cursor-img">
                <FileUploadOutlinedIcon
                  className="fs-1 align-middle me-1 text-secondary"
                  style={{ transform: "rotate(0deg)" }}
                />
              </label>
            </>
          )}

          <input
            type="file"
            id="logoInput"
            name="logo"
            accept=".jpg, .jpeg, .png"
            style={{ display: "none" }}
            onChange={(e) =>
              handleImageChange(e)
            }
            ref={inputFileRef}
          />
        </div>
      </div>
    </FormGroup>
  )
}